import { Typography } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import useMosInfo from './../common/provider/useMosInfo'

const InspectionReportWidgetToolbar = () => {
  const { node, taskReference } = useMosInfo()
  const { t_ } = useSmartTranslation()
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content', gap: '0.2rem 0.5rem', textAlign: 'left', alignItems: 'center' }}>
      <Typography variant='h6'>{t_('Job') + ':'}</Typography><Typography variant='h5'>{node?.name}</Typography>
      <Typography variant='h6'>{t_('Task') + ':'}</Typography><Typography variant='h5'>{taskReference?.name}</Typography>
    </div>
  )
}

export default InspectionReportWidgetToolbar
